import {ContentType, HttpClient, type RequestParams} from "~/types/api/api";

export interface EventRequestDto<T> {
    userId: string
    eventName: string
    eventTime: string,
    eventData: T
}


export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
    licenceCode?: string;

    constructor(baseUrl: string, zeblineLicenseCode?: string) {
        super({baseURL: baseUrl});
        this.licenceCode = zeblineLicenseCode;
    }

    api = {
        /**
         * No description
         *
         * @tags Attachment
         * @name Event
         * @request POST:/v1/accounts/{YOUR_ZEBLINE_LICENCE_CODE}/events
         * @secure
         */
        event: <T>(data: EventRequestDto<T>, params: RequestParams = {}) =>
            console.log({
                path: `/accounts/${this.licenceCode}/events`,
                method: "POST",
                body: data,
                ...params,
            }),
    }
}